module.exports = __webpack_public_path__ + "img/ec5e2cd6e244b1dccd7d02a2b5854213.cefb7fe1.png";